"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableLoadingRow = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var Spinner_1 = require("../../Spinner");
var Table_1 = require("../Table");
function TableLoadingRow(props) {
    var colSpan = props.colSpan, message = props.message;
    var classes = styles_1.useStyles(createStyles).classes;
    return (react_1.default.createElement(Table_1.TableRow, null,
        react_1.default.createElement(Table_1.TableCell, { colSpan: colSpan, style: classes.cell },
            react_1.default.createElement("div", { className: classes.container },
                react_1.default.createElement(Spinner_1.Spinner, null),
                message))));
}
exports.TableLoadingRow = TableLoadingRow;
TableLoadingRow.defaultProps = {
    message: 'Carregando resultados',
};
var createStyles = function (theme) { return ({
    cell: {
        background: theme.pallete.surface.background,
        color: theme.pallete.primary.main,
        fontWeight: 'bold',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& > *:first-of-type': {
            marginRight: '0.5rem',
        },
    },
}); };
//# sourceMappingURL=TableLoadingRow.js.map